import _ from 'lodash'

function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item)
}

Object.deepMerge = function (target, source) {
    let output = Object.assign({}, target) // Create a copy of the target object

    if (!isObject(target) || !isObject(source)) {
        throw new Error('deepMerge must be called with two objects')
    }

    Object.keys(source).forEach((key) => {
        if (isObject(source[key]) && isObject(target[key])) {
            output[key] = this.deepMerge(target[key], source[key])
        } else {
            output[key] = source[key]
        }
    })
    return output
}

Object.deepCopy = function (source) {
    return _.cloneDeep(source)
}
// CANT OVERRIDE OBJECT PROTOTYPE IN VUE

// Function to sort array values in a consistent manner
function sortArrayValues(a) {
    return Array.isArray(a) ? [...a].sort().map(sortArrayValues) : a
}

// Function to stringify object values consistently
function stringifyObjectValues(obj) {
    return Object.keys(obj)
        .sort()
        .map((key) => {
            const value = obj[key]
            if (Array.isArray(value)) {
                return `${key}:${JSON.stringify(sortArrayValues(value))}`
            }
            if (value instanceof Date) {
                return `${key}:${value}`
            }
            if (typeof value === 'object' && value !== null) {
                return `${key}:${stringifyObjectValues(value)}`
            }
            return `${key}:${value}`
        })
        .join(',')
}

// a function that flattens a complex object into a series
Object.hash = function (obj) {
    // Stringify the object values consistently
    const objectString = stringifyObjectValues(obj)

    // Create a hash of the stringified object
    const encoder = new TextEncoder()
    const data = encoder.encode(objectString)
    const digestBuffer = crypto.subtle.digest('SHA-256', data)

    // Convert the hash to a hexadecimal string
    async function bufferToHexString(buffer) {
        const byteArray = new Uint8Array(await buffer)
        const hexCodes = Array.from(byteArray, (byte) => {
            return byte.toString(16).padStart(2, '0')
        })

        return hexCodes.join('')
    }

    return bufferToHexString(digestBuffer)
}
